/**
 * KullaniciEkleDugmesi.jsx — "Kullanıcı ekle" + "Yeni kullanıcı oluştur" düğmeleri ve pencereleri (2026-10-19; #628 2026-10-30)
 *
 * İki yerde aynı: Firma Detay › Profil & Belgeler › Kullanıcılar ve › Portal Kullanıcıları. #628'den beri backend, firma tarafı girişi
 * oluşturmayı / firmaya bağlamayı MANAGE_USER_ROLES ya da kullanici.olustur sahibine açar (Admin, Kayıt ve Saha rolleri); izni olmayana
 * düğmeler GİZLENMEZ, kapalı çizilir ve nedenini söyler — "düğme yok" ile "iznim yok" ayırt edilebilsin.
 * WAS (until #628): yalnızca rbac.manage (kök geçer) — dev'de hiçbir rolde olmadığından kimse bağlayamıyordu.
 */
import React, { useState } from "react";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useYetki, PERMISSION_KEYS } from "../../../../services/rbacService";
import FirmaKullaniciEkleModal from "./FirmaKullaniciEkleModal";
import UserFormModal from "../../Users/UserFormModal";

/**
 * @param {number}   firmaId
 * @param {string}   firmaAdi
 * @param {Function} onEklendi  (kullaniciAdi) => void — bağlama / oluşturma başarılı olunca (pencere kapanmıştır)
 */
export default function KullaniciEkleDugmesi({ firmaId, firmaAdi, onEklendi }) {
  const { t } = useTranslation("ayarlar");
  const yonetici = useYetki(PERMISSION_KEYS.MANAGE_USER_ROLES);
  const olusturucu = useYetki(PERMISSION_KEYS.KULLANICI_OLUSTUR);
  // WAS (until #628): const izinli = useYetki(PERMISSION_KEYS.RBAC_MANAGE) === true;
  const izinli = yonetici === true || olusturucu === true;
  const [acik, setAcik] = useState(null); // "ekle" | "yeni" | null

  return (
    <>
      {/* Kapalı düğme fare olaylarını yutar: ipucu sarmalayıcıda durur. */}
      <span title={izinli ? undefined : t("portalKullanicilari.eklemeYetkisi")} className="d-inline-flex gap-2">
        <Button color="primary" size="sm" disabled={!izinli} onClick={() => setAcik("ekle")} data-testid="portal-kullanici-ekle">
          <i className="bx bx-user-plus me-1" />{t("portalKullanicilari.kullaniciEkle")}
        </Button>
        <Button color="outline-primary" size="sm" disabled={!izinli} onClick={() => setAcik("yeni")} data-testid="portal-kullanici-olustur">
          <i className="bx bx-plus me-1" />{t("portalKullanicilari.yeniKullaniciOlustur")}
        </Button>
      </span>
      {acik === "ekle" && (
        <FirmaKullaniciEkleModal
          firmaId={firmaId} firmaAdi={firmaAdi}
          toggle={() => setAcik(null)}
          onEklendi={(kullanici) => { setAcik(null); onEklendi(kullanici); }}
        />
      )}
      {acik === "yeni" && (
        <UserFormModal
          mode="create" firma={{ id: firmaId, ad: firmaAdi }}
          onClose={(sonuc) => {
            setAcik(null);
            if (sonuc?.olustu) onEklendi(sonuc.kullaniciAdi || `#${sonuc.userId}`);
          }}
        />
      )}
    </>
  );
}
